export default {"src":"/kaimono/_next/static/media/wamazing_stay_h.cbaa564f.svg","height":117,"width":406};